import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import ChirpPropShapes from 'javascripts/shared/chirp_prop_shapes';

import { CoverImage } from 'javascripts/components/cover_image';

import { bubEvents } from 'javascripts/shared/events/bub_events';

import styles from 'stylesheets/components/book_card_condensed';

export function BookCardCondensed({ audiobook, defer, openNewTab, showPrices, trackingCategory, trackingProperties }) {
  const shouldShowPrices = useMemo(() => {
    return showPrices && !_.isEmpty(audiobook.currentProduct);
  }, [showPrices, audiobook.currentProduct]);

  function trackCoverClick() {
    if (!_.isNil(trackingCategory)) {
      bubEvents.track(trackingCategory, 'Clicked audiobook cover', {
        ...trackingProperties,
        label: 'Audiobook id',
        value: audiobook.id,
      });
    }
  }

  function renderListingPrice() {
    if (audiobook.currentProduct.isFreeListing) {
      return <div className={styles.freeListing}>Our Price:</div>;
    }

    if (!audiobook.currentProduct.showListingPrice) {
      return null;
    }

    return <div className={styles.listingPrice}>{audiobook.currentProduct.listingPrice}</div>;
  }

  function renderPrices() {
    if (!shouldShowPrices) {
      return null;
    }

    return (
      <div className={styles.pricing}>
        {renderListingPrice()}
        <div className={styles.discountPrice}>{audiobook.currentProduct.discountPrice}</div>
      </div>
    );
  }

  return (
    <div className={styles.bookCardCondensed} data-testid='book-card-condensed'>
      <CoverImage
        bookAuthor={audiobook.displayAuthors}
        bookTitle={audiobook.displayTitle}
        coverUrl={audiobook.coverUrl}
        defer={defer}
        linkUrl={audiobook.url}
        onClick={trackCoverClick}
        openNewTab={openNewTab}
        bannerType={audiobook.currentProduct?.bannerType}
      />
      {renderPrices()}
    </div>
  );
}

BookCardCondensed.propTypes = {
  audiobook: ChirpPropShapes.audiobook.isRequired,
  defer: PropTypes.bool,
  openNewTab: PropTypes.bool,
  showPrices: PropTypes.bool,
  trackingCategory: PropTypes.string,
  trackingProperties: PropTypes.object,
};

BookCardCondensed.defaultProps = {
  defer: true,
  openNewTab: false,
  showPrices: false,
  trackingProperties: {},
};
